import React from 'react'
import './GrearestCompanies.css'
import BlueButton3 from './BlueButton3'
import LogoBrick from './LogoBrick'
import HivioLogo from '../images/svg/hiviologo.svg'
import TcoLogo from '../images/svg/tcologo.svg'
import SchLogo from '../images/svg/schlogo.svg'
import SesvanLogo from '../images/svg/sesvanlogo.svg'
import HardRockLogo from '../images/svg/hardrocklogo.svg'
import HavenLogo from '../images/svg/hevenlogo.svg'
import HiltonLogo from '../images/svg/hilton.svg'
import SheratonLogo from '../images/svg/sheratonlogo.svg'
import JaguarLogo from '../images/svg/jaguarlogo.svg'




function GreatestCompanies() {
    return (
        <div className='container-grid'>
            <div className='left'>
                <h3 className='we-only-work'>Enter the realm of AI-powered<br />
                    <span className='text-row-2'>marketing systems and</span><br />
                    <span className='text-row-3'> go beyond.</span>
                </h3>
                <p className='we-are-global-agency'>
                    From content to customer support and acquisition - we turn marketing<br /> into a system that runs every day, not a set of one-off actions.
                </p>
                <div className='contact-us-button'>
                    <BlueButton3
                        text='Contact us'
                    />
                </div>
            </div>
            <div className='right'>
                <div className='logos-grid'>
                    <LogoBrick
                        src={HivioLogo}
                        alt='Hivio Logo'

                    />
                    <LogoBrick
                        src={TcoLogo}
                        alt='Tco Logo'

                    />
                    <LogoBrick
                        src={SchLogo}
                        alt='Scharmach Logo'

                    />
                    <LogoBrick
                        src={SesvanLogo}
                        alt='Sesvan Logo'

                    />
                    <LogoBrick
                        src={HardRockLogo}
                        alt='Hard Rock Logo'

                    />
                    <LogoBrick
                        src={HavenLogo}
                        alt='Heven Logo'

                    />
                    <LogoBrick
                        src={HiltonLogo}
                        alt='Hilton Logo'

                    />
                    <LogoBrick
                        src={SheratonLogo}
                        alt='Sheraton Logo'

                    />
                    <LogoBrick
                        src={JaguarLogo}
                        alt='Jaguar Logo'
                    />

                </div>
                <div className='more-clients'>


                </div>

            </div>
        </div>
    )
}

export default GreatestCompanies